import { render, staticRenderFns } from "./Station.vue?vue&type=template&id=4d285ed0&scoped=true"
import script from "./Station.vue?vue&type=script&lang=js"
export * from "./Station.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d285ed0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d285ed0')) {
      api.createRecord('4d285ed0', component.options)
    } else {
      api.reload('4d285ed0', component.options)
    }
    module.hot.accept("./Station.vue?vue&type=template&id=4d285ed0&scoped=true", function () {
      api.rerender('4d285ed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/Station.vue"
export default component.exports